// extracted by css-extract-rspack-plugin
export default {"message":"GSkYadvG1uwLnDdw"};